var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-footer-documents"},_vm._l((_vm.documents),function(document,i){return _c('div',{key:i,staticClass:"common-footer-documents__item"},[_c('a',{staticClass:"common-footer-documents__item-link",attrs:{"href":document.url,"target":document.target || '_blank'},domProps:{"textContent":_vm._s(document.title)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }